import { Button, Modal } from "antd";
import { FaBalanceScale, FaShieldAlt } from "react-icons/fa";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { HiRocketLaunch } from "react-icons/hi2";
import { AiTwotoneFire } from "react-icons/ai";
import styles from "../../../styles/Components/alert-system/alert-config/RiskAppetiteModal.module.css";
import React, { useState } from "react";
import { FaChartLine } from "react-icons/fa6";
import { useSelector } from "react-redux";
import useChangeAlertSystemSettings from "../../../hooks/api/alert-system/useChangeAlertSystemSettings";

const riskOptions = [
  {
    value: "1",
    label: "Very Cautious",
    icon: <FaShieldAlt color="#ff0000" />,
  },
  {
    value: "2",
    label: "Cautious",
    icon: <BsExclamationTriangleFill color="#ffa500" />,
  },
  {
    value: "3",
    label: "Balanced",
    icon: <FaBalanceScale color="#02a82b" />,
  },
  {
    value: "4",
    label: "Adventurous",
    icon: <HiRocketLaunch color="#00bfff" />,
  },
  {
    value: "5",
    label: "Very Adventurous",
    icon: <AiTwotoneFire color="#022da1" />,
  },
];

function RiskAppetiteModal({ open, onClose }) {
  const { activeAlertLoading, alertStatus } = useSelector(
    (state) => state.alertSystem,
  );

  const changeSettings = useChangeAlertSystemSettings();

  const [selectedRisk, setSelectedRisk] = useState(
    alertStatus?.risk_taking_amount || "3",
  );

  const closeModal = (e) => {
    e.stopPropagation();
    onClose();
  };

  const selectRisk = (e, risk) => {
    e.stopPropagation();
    setSelectedRisk(risk);
  };

  const submitHandler = (e) => {
    e.stopPropagation();
    changeSettings({ riskAppetite: selectedRisk }).then(() => onClose());
  };

  return (
    <Modal
      open={open}
      onCancel={closeModal}
      title={
        <div className={styles.modalTitleContainer}>
          <FaChartLine className={styles.modalIcon} />
          <span>Select Risk Appetite</span>
        </div>
      }
      footer={null}
    >
      <div className={styles.riskOptions}>
        {riskOptions.map((risk) => (
          <div
            key={risk.value}
            className={`${styles.riskOption} ${selectedRisk === risk.value ? styles.selected : ""}`}
            onClick={(e) => selectRisk(e, risk.value)}
          >
            {risk.icon} <span>{risk.label}</span>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <Button
          className={styles.submitBtn}
          loading={activeAlertLoading}
          disabled={!selectedRisk}
          onClick={submitHandler}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
}

export default RiskAppetiteModal;
